<tc-layout
  [user]="shellUser()"
  [logoUrl]="logoUrl()"
  [brandLabel]="brandLabel"
  [showThemeToggle]="false"
  [showTourOverlay]="false"
  [showToastOutlet]="false"
  (logout)="logout()"
>
  <div tcLayoutActions class="flex items-center gap-2.5">
    <tc-theme-toggle />
    <tc-badge
      [label]="versionLabel"
      variant="gray"
      [attr.title]="'Verze aplikace ' + versionLabel"
    />
  </div>

  <div tcLayoutBody class="layout-body relative h-full min-h-0 overflow-hidden p-6">
    <router-outlet />
  </div>
</tc-layout>

<app-toast-container />
